/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
import Modal from "../components/modal/Modal";
import { SecurityData } from "../utils/helpers/types";

interface SecurityDataModalProps {
  securityData: SecurityData | null;
  onCancel: () => void;
  visible: boolean;
}

const SecurityDataModal: React.FC<SecurityDataModalProps> = ({
  securityData,
  onCancel,
  visible
}) => {
  const formatSecurityData = (data: string, type: string): string => {
    const parsedData = JSON.parse(data);
    let formattedData = "";
    formattedData += `<strong>Type:</strong> ${type}<br/><br/>`;

    if (type === "symmetric") {
      formattedData += `
          <strong>Encryption Key:</strong> ${parsedData.encryptionKey}<br/><br/>
          <strong>Initial Vector:</strong> ${parsedData.iv}
        `;
    } else {
      for (const [key, value] of Object.entries(parsedData)) {
        formattedData += `<strong>${key}:</strong> ${value}<br/><br/>`;
      }
    }

    return formattedData;
  };

  return (
    <Modal cancel={onCancel} visible={visible}>
      {securityData && (
        <div>
          <br />
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: formatSecurityData(securityData.data, securityData.type)
              }}
            />
          </p>
        </div>
      )}
    </Modal>
  );
};
export default SecurityDataModal;
